import branchChoose from './branch-choose'
export default {
	items: [branchChoose]
} 
